import $http from '@/utils/fetch'

const getTicket = (url) => {
  return $http.post('wxpub/getJsApiSignature', { url })
}

export default {
  getTicket
}